import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Smartphone } from 'lucide-react';
import { useIsMobilePortrait } from '@/hooks/use-mobile';

// 手机竖屏「请横屏」提示浮窗：铺满的半透明遮罩 + 居中卡片。
// 仅在窄屏纵向(useIsMobilePortrait)时渲染 —— 转到横屏后现有 844×390 舞台接管、本浮窗自动消失,
// 转回竖屏再现,不做记忆、不可手动关闭(遮罩不阻断「旋转」这一唯一期望动作)。
// 挂载点见 Dashboard.tsx(isStudent 门控),portal 到 body 以浮于一切之上。

export default function LandscapeHint() {
  const { t } = useTranslation();
  const show = useIsMobilePortrait();
  if (!show) return null;

  return createPortal(
    <div
      role="alertdialog"
      aria-live="polite"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'rgba(0,0,0,0.72)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }}
    >
      {/* 图标「竖→横」摆动动画,直观传达「旋转」 */}
      <style>{`@keyframes landscapeHintRotate{0%,40%{transform:rotate(0deg)}70%,100%{transform:rotate(90deg)}}`}</style>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          maxWidth: 320,
          padding: '32px 28px',
          borderRadius: 24,
          background: '#fff',
          boxShadow: '0 12px 40px -8px rgba(0,0,0,0.4)',
          textAlign: 'center',
        }}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: 'color-mix(in srgb, var(--primary) 14%, transparent)',
            color: 'var(--primary)',
          }}
        >
          <Smartphone
            size={36}
            style={{
              transformOrigin: 'center',
              animation: 'landscapeHintRotate 2.4s ease-in-out infinite',
            }}
          />
        </span>
        <div style={{ fontSize: 17, fontWeight: 600, color: '#111', fontFamily: 'var(--font-sans)' }}>
          {t('common.landscape-hint-title')}
        </div>
        <div style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.5, fontFamily: 'var(--font-sans)' }}>
          {t('common.landscape-hint-desc')}
        </div>
      </div>
    </div>,
    document.body,
  );
}
